'use strict';

const base = require('../home/base.es');
const createEntryPointContext = require('../global/reactHelpers/createEntryPointContext');
const SV = require('server-vars');

const context = createEntryPointContext([
    require('../global/stores/RecommendationsStore'),
    require('../global/stores/TrendingStore'),
    require('../global/stores/TradeMessageStore')
]);

require('../../scss/home/base.scss');

base.init({
    context: context,
    data: SV.get('data')
});



// WEBPACK FOOTER //
// ./assets/js/entries/home.es.js